import axios from "axios";
import Config from "../Config";
import RequestUtil from "@/utils/RequestUtil.js";

export default {
  getGdsPolicyTotal(param, config) {
    const url = `${Config.API_DOMAIN}/ext/gds/v1.0/policy/total${RequestUtil.getPasingParam(param)}`;
    return axios.get(url, config);
  }
};
